<template>
  <div class="px-7.5 py-5 shadow-bordered rounded-md bg-white text-center md:max-w-1.5xl mx-auto my-6 lg:my-10">
    <p class="text-lg md:text-xl font-bold mt-3">
      {{ props.title }}
    </p>

    <!-- eslint-disable vue/no-v-html -->

    <div
      class="text-base md:text-lg"
      v-html="props.subtitle"
    >
    </div>

    <div class="my-6 mx-auto grid grid-cols-2 gap-x-4 gap-y-4 md:grid-cols-4">
      <div
        v-for="(option, index) in options"
        :id="`'cta-inline-partner-${option.name}`"
        :key="index"
        class="px-0 py-0 shadow-bordered rounded-md bg-white text-center mx-auto cursor-pointer border-2 border-white hover:border-2 hover:border-success w-full"
      >
        <atoms-cta
          :to="option.link"
          class="w-full h-full flex justify-center items-center"
          size="small"
          theme="plain"
        >
          <AtomsImage
            v-if="option.image"
            width="auto"
            height="44"
            :alt="`cta-inline-partner-${option.name.toLowerCase()}`"
            :src="option.image"
            class="max-h-44 px-2 my-2"
          />
          <p
            v-else
            class="text-lg font-bold text-success"
          >
            {{ option.name }}
          </p>
        </atoms-cta>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ENERGY_PARTNERS_LIST } from '@/helpers/partners.constants'

defineOptions({
  name: 'MoleculesInlinePartner'
})

const props = defineProps({
  ctaId: {
    type: String,
    default: 'inline-card-cta'
  },
  ctaClass: {
    type: String,
    default: ''
  },
  componentVertical: {
    type: String,
    default: 'Home Loans'
  },
  customComponent: {
    type: Object,
    default: () => ({})
  },
  title: {
    type: String,
    default: 'Select your state and compare now!'
  },
  subtitle: {
    type: String,
    default: 'Discover the best options for you'
  },
  redirectUrl: {
    type: String,
    default: '/home-loans/quote/form/step1/'
  },
  ctaType: {
    type: String,
    default: 'State'
  }
})

const options = ENERGY_PARTNERS_LIST
</script>
